module.exports = __webpack_public_path__ + "static/img/son1.0a5f2611.png";